function setAccordion({ selector, buttonClass, ariaLabel = false }) {
  if (!selector || !buttonClass) return;

  const containers = document.querySelectorAll(selector);

  containers.forEach((container) => {
    const accordions = container.querySelectorAll(`.${buttonClass}`);

    accordions.forEach((accordion) => {
      // Prevent multiple event listeners
      if (accordion.dataset.accordionInitialized) return;
      accordion.dataset.accordionInitialized = 'true';

      // Check if aria-expanded is true on page load and open accordion
      if (ariaLabel && accordion.getAttribute('aria-expanded') === 'true') {
        accordion.classList.add('is-active');
        const panel = accordion.nextElementSibling;
        if (panel) {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        }
      }

      accordion.addEventListener('click', () => {
        accordion.classList.toggle('is-active');
        // Handle aria-expanded attribute
        if (ariaLabel) {
          const isExpanded = accordion.getAttribute('aria-expanded') === 'true';
          accordion.setAttribute('aria-expanded', !isExpanded);
        }

        const panel = accordion.nextElementSibling;
        // Toggle panel height
        if (panel) {
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = `${panel.scrollHeight}px`;
          }
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setAccordion({
    selector: '.js-accordion',
    buttonClass: 'js-accordion-item',
    ariaLabel: true
  });
});
